**Sharpe Ratio** is defined as the risk-adjusted excess return of the index (average
return earned in excess of the risk-free rate per standard deviation). 3-month
US Treasury Bill is chosen as the risk-free rate. The rolling interval determines
the time period used for calculation for each Sharpe Ratio value.
